import UIkit from 'uikit';

export default {
  init() {
    // JavaScript to be fired on pages that use the Sticky CTA sidebar layout (or Lead gen page template)
    $(document).ready(function () {
        if ($('[uk-offcanvas]').length) {
          if (window.location.href.indexOf('?tfa_next=') > -1) {
            setTimeout(function () {
              UIkit.offcanvas('#sticky-drawer').show();
            }, 1000)
          }
        }
        $('.sticky-cta-layout > div.uk-visible-1200 .wfPageNextButton, .sticky-cta-layout > div.uk-visible-1200 #submit_button, .sticky-cta-layout > div.uk-visible-1200 .wfPagePreviousButton').click(function () {
          $(window).trigger('resize');
          // UIkit.update('.sticky-cta-layout > div.uk-visible-1200')
        })
        $(window).on('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            moveStickyCTAForm();
          }, 250);
        });
        setTimeout(function () {
          moveStickyCTAForm();
        }, 1000)

      function moveStickyCTAForm()
      {
        if ($('.page-template-page-lead-gen-page .sticky-wrap.mobile:visible').length > 0 == true) {
          if ($('.form-placeholder-mobile:not(:has(.wFormContainer))').length > 0 == true) {
            console.log('first if');
            let mwhForm = $('#sticky-form-container')
            $('.mwh-mobile-form .form-placeholder-mobile').append(mwhForm)
          }
        } else if ($('.page-template-page-lead-gen-page .sticky-cta-layout .sticky-wrap:visible').length > 0 == true) {
          UIkit.offcanvas('#sticky-drawer').hide();
          if ($('.form-placeholder-desktop:not(:has(.wFormContainer))').length > 0 == true) {
            console.log('second if');
            let mwhForm = $('#sticky-form-container')
            $('#mwh-form .form-placeholder-desktop').append(mwhForm)
          }
        }
      }
// recalculate heights on page resizes with timeout
      var resizeTimer;
      $(window).on('resize', function () {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {

          moveStickyCTAForm();

        }, 250);

      });

    //  Reveal sidebar image after scrolling past page hero
      let stickyImg = $('.sticky-cta-layout .sticky-wrap > div.uk-sticky > img.reveal-image-on-scroll'),
        imgMargin = stickyImg.css('margin-top')
      if (stickyImg.length) {
        let heroHeight = $('div.flex-layout-wrap > div:first-of-type').outerHeight()

        $(window).on('scroll', function () {
          if ($(window).scrollTop() >= heroHeight) {
            stickyImg.css('margin-top', '0')
          } else {
            stickyImg.css('margin-top', imgMargin)
          }
        })
      }
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/leadGenSidebar.js